// extracted by mini-css-extract-plugin
module.exports = {"li":"DotList_li_Kr284"};